/** 公告列表 → 详情：元数据不入 URL，仅存 session（短链接可分享 /announcements/:id） */
const PREFIX = "lst_ann_meta:";

export function saveNoticeMeta(noticeId, meta) {
    const id = noticeId != null ? String(noticeId).trim() : "";
    if (!id)
        return;
    try {
        sessionStorage.setItem(PREFIX + id, JSON.stringify(meta || {}));
    }
    catch {
        /* ignore quota */
    }
}

export function loadNoticeMeta(noticeId) {
    const id = noticeId != null ? String(noticeId).trim() : "";
    if (!id)
        return null;
    try {
        const raw = sessionStorage.getItem(PREFIX + id);
        if (!raw)
            return null;
        return JSON.parse(raw);
    }
    catch {
        return null;
    }
}
